import React from "react";
import useMediaTranslation from "app/app/mediaSelector/hooks/use-translation";

function MediaItemPreviewOnly({media}) {
    const trans = useMediaTranslation();
    const {url, title, alt, sizes, photographAuthorEmail} = media;

    return (
        <div className={'media-item media-item--not-downloadable'} >
            <div className={'media-item__image-container object-fit'}>
                <img src={sizes.medium_large} alt={alt}/>
            </div>

            <div className={'media-item-not-downloadable-badge'}>
                {trans.media_grid.contact_desc}
            </div>

            <div className={'media-item__inner'}>
                <div className={'media-item-info'}>
                    <h3>{title}</h3>
                    <a
                        href={`mailto: ${photographAuthorEmail}?subject=Vedr. brug af billede fra Ulandssekretariatet&body=Din besked til fotograf, vedr brug af billede dette billede ${sizes.medium}
                    `}
                       className={'button small transparent'}
                    >
                        {trans.media_grid.contact_btn}
                    </a>
                </div>
            </div>
        </div>
    );
}

export default MediaItemPreviewOnly;
